// mds-dojo — dijit/form/MappedTextBox — FAITHFUL port of references/dijit/form/MappedTextBox.js.
// Codemod pipeline; declare from the faithful runtime. Adaptations:
//  - `dojo/sniff` → `dojo/has`: has("msapp") is undefined under evergreen → the hidden <input>
//    always receives its name attribute (correct behavior for non-Windows-Store apps).
// A ValidationTextBox subclass with a hidden serialized value node submitted to the server.
import declare from '../../dojo/_base/declare-runtime'; // declare
import has from '../../dojo/has'; // has("msapp")
import domConstruct from '../../dojo/dom-construct'; // domConstruct.place
import ValidationTextBox from './ValidationTextBox';

export default declare("dijit.form.MappedTextBox", ValidationTextBox, {
	// summary:
	//		A dijit/form/ValidationTextBox subclass which provides a base class for widgets that have
	//		a visible formatted display value, and a serializable
	//		value in a hidden input field which is actually sent to the server.
	// tags:
	//		protected

	postMixInProperties: function () {
		this.inherited(arguments);

		// We want the name attribute to go to the hidden <input>, not the displayed <input>,
		// so override _FormWidget.postMixInProperties() setting of nameAttrSetting for IE.
		this.nameAttrSetting = "";
	},

	// Remap name attribute to be mapped to hidden node created in buildRendering(), rather than this.focusNode
	_setNameAttr: "valueNode",

	serialize: function (val: any /*=====, options =====*/) {
		// summary:
		//		Overridable function used to convert the get('value') result to a canonical
		//		(non-localized) string.
		// tags:
		//		protected extension
		return val.toString ? val.toString() : ""; // String
	},

	toString: function () {
		// summary:
		//		Returns widget as a printable string using the widget's value
		// tags:
		//		protected
		var val = this.filter(this.get('value')); // call filter in case value is nonstring and filter has been customized
		return val != null ? (typeof val == "string" ? val : this.serialize(val, this.constraints)) : ""; // String
	},

	validate: function () {
		// Overrides `dijit/form/TextBox.validate`
		this.valueNode.value = this.toString();
		return this.inherited(arguments);
	},

	buildRendering: function () {
		// Overrides `dijit/_TemplatedMixin/buildRendering`

		this.inherited(arguments);

		// Create a hidden <input> node with the serialized value used for submit
		// (as opposed to the displayed value).
		this.valueNode = domConstruct.place("<input type='hidden'" +
			((this.name && !has("msapp")) ? ' name="' + this.name.replace(/"/g, "&quot;") + '"' : "") + "/>",
			this.textbox, "after");
	},

	reset: function () {
		// Overrides `dijit/form/ValidationTextBox.reset` to
		// reset the hidden textbox value to ''
		this.valueNode.value = '';
		this.inherited(arguments);
	}
});
